export const TYPE_TASK:any = [
  { value: 0, label: 'Пропущенный звонок' },
  { value: 1, label: 'Обратный звонок' },
  { value: 2, label: 'E-mail' },
  { value: 3, label: 'Напоминание' },
  { value: 4, label: 'Звонок' },
  { value: 5, label: 'Задача руководства' },
  { value: 6, label: 'Заявка' },
  { value: 7, label: 'Контрагент' },
  { value: 8, label: 'Прочее' },
  { value: 9, label: 'Лендинг' },
  { value: 10, label: 'Все' },
]
export const TYPE_TASK_TITLE:any = {
  0: { value: 0, label: 'Пропущенный звонок' },
  1: { value: 1, label: 'Обратный звонок' },
  2: { value: 2, label: 'E-mail' },
  3: { value: 3, label: 'Напоминание' },
  4: { value: 4, label: 'Звонок' },
  5: { value: 5, label: 'Задача руководства' },
  6:  { value: 6, label: 'Заявка' },
  7: { value: 7, label: 'Контрагент' },
  8: { value: 8, label: 'Прочее' },
  9: { value: 9, label: 'Лендинг' },
}

export const STATUS_TASK = [
  { status: 'NEW', value: 0, label: 'Новая' },
  { status: 'OVERDUE', value: 1, label: 'Просрочена' },
  { status: 'STARTED', value: 2, label: 'В работе' },
  { status: 'CLOSED', value: 3, label: 'Закрыта' },
  { status: 'All', value: 4, label: 'Все' },
  { status: 'Opened', value: 5, label: 'Открыта' },
]
export const STATUSES_TASK_OPENED = [STATUS_TASK[0].status, STATUS_TASK[1].status, STATUS_TASK[2].status]
export const DAYS_WEEK_TASK = [
  { value: 1, label: 'Понедельник' },
  { value: 2, label: 'Вторник' },
  { value: 3, label: 'Среда' },
  { value: 4, label: 'Четверг' },
  { value: 5, label: 'Пятница' },
  { value: 6, label: 'Суббота' },
  { value: 7, label: 'Воскресенье' },
]
export const MONTH_WEEK_TASK = [
  { value: 1, label: 'Январь' },
  { value: 2, label: 'Февраль' },
  { value: 3, label: 'Март' },
  { value: 4, label: 'Апрель' },
  { value: 5, label: 'Май' },
  { value: 6, label: 'Июнь' },
  { value: 7, label: 'Июль' },
  { value: 8, label: 'Август' },
  { value: 9, label: 'Сентябрь' },
  { value: 10, label: 'Октябрь' },
  { value: 11, label: 'Ноябрь' },
  { value: 12, label: 'Декабрь' },
]
export const defaultFiltersValue = {
  nameTask: undefined,
  customer: undefined,
  source: undefined,
  state: [STATUS_TASK[5].status],
  start_at: undefined,
  deadline_at: undefined,
  created_at: undefined,
  closed_at: undefined,
  isMine: false,
}

export const TASKS_STATUS_TYPE = {
  CLOSED: 'CLOSED',
  NEW: 'NEW',
  OVERDUE: 'OVERDUE',
  REOPEN: 'REOPEN',
  STARTED: 'STARTED',
}